/**
 * harness/clipboard.js
 * T-Cron-2026-10-24 02:00 早间 (round-1-of-day) — 改进清单 #8「批量操作」
 *
 * 为什么抽成共享模块:
 *   PostDetail 里已经有一套「三段式复制」(主路径 → 老 webview 兜底 → 失败
 *   提示),本轮新增的「批量复制」需要**同一套语义**。两份实现必然漂移:
 *   一份修好了华为 webview 的兜底,另一份没修 ⇒ 用户看到的行为不一致。
 *   ⇒ 抽成单一事实来源,PostDetail 与 App 都调它。
 *
 * 三段式(与 PostDetail 原实现逐字等价,只是搬家):
 *   1. 主路径 navigator.clipboard.writeText —— 现代浏览器 / PWA
 *   2. 兜底 textarea + document.execCommand('copy') —— 老 webview 唯一可行的路
 *      (华为/鸿蒙 webview、微信内置浏览器、飞书内置浏览器)
 *   3. 两条都失败 ⇒ 返回 false,由调用方**必须**给用户明确反馈,
 *      不能静默返回(静默失败 = 用户以为按钮坏了)。
 *
 * 注意:本文件是 .js 且不含 JSX ⇒ vite.config.js 的 esbuild.jsxInject
 * 只对 .jsx 生效,这里不涉及 React,无需 import React。
 */

/**
 * 把文本写入剪贴板。
 * @param {string} text
 * @returns {Promise<boolean>} true = 已写入;false = 两条路径都失败
 */
export async function copyToClipboard(text) {
  if (text === null || text === undefined) return false;
  const payload = String(text);
  if (!payload) return false;

  // 1) 现代路径
  try {
    if (typeof navigator !== 'undefined'
      && navigator.clipboard
      && typeof navigator.clipboard.writeText === 'function') {
      await navigator.clipboard.writeText(payload);
      return true;
    }
  } catch (_) {
    // 落到 2)
  }

  // 2) 老 webview 兜底:隐藏 textarea + execCommand
  try {
    const ta = document.createElement('textarea');
    ta.value = payload;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    ta.style.top = '0';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    ta.setSelectionRange(0, payload.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return !!ok;
  } catch (_) {
    return false;
  }
}

const ClipboardHelper = { copyToClipboard };

window.ClipboardHelper = ClipboardHelper;

export default ClipboardHelper;
